import { getAdminOrgId } from "lib/site";
import Dashboard from "screens/components//Dashboard";

function AdminOverview() {
    return <Dashboard organisationId={getAdminOrgId()}></Dashboard>
}

export default AdminOverview;
